import { useState } from 'react'
import Image from 'next/image'
import { useTranslation, Trans } from 'next-i18next'

import { redirectInstant } from 'utility-tools/module/routing'
import styled from '@emotion/styled'
import { FooterElement, Legal, OrderTrack } from '@/components/Footer/Footer.styles'
import Anchor from '@/elements/anchor/Anchor'
import Link from 'next/link'

const currentYear = new Date().getFullYear()

export const Divider = styled.div`
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.24);
    margin-top: 2rem;
`

const LogoContainer = styled.div`
    display: flex;
    justify-content: flex-start;

    @media (max-width: 768px) {
        justify-content: center;
        align-items: center;
    }
`

const FooterText = styled.p`
    color: white;
    font-size: 1rem;
    margin: 0;
    text-align: left;
    padding: 0;

    @media (max-width: 768px) {
        text-align: center;
        padding: 0 1rem;
    }
`

const FooterLinks = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    gap: 2rem;
    justify-content: flex-end;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 1.5rem;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 1rem 0;
    }

    li {
        a {
            color: white;
            text-decoration: none;
            font-size: 1.3rem;
            font-weight: 500;
            opacity: 0.9;
            transition: opacity 0.2s ease;
            position: relative;

            &:hover {
                opacity: 1;
                text-decoration: underline;

                &:after {
                    opacity: 1;
                }
            }

            @media (max-width: 768px) {
                font-size: 1.2rem;
            }
        }
    }
`

const FooterContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 0 2rem;
`

const FooterContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.5rem;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
    }
`

const FooterInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @media (max-width: 768px) {
        align-items: center;
        gap: 1.5rem;
    }
`

const Footer = () => {
    const { t } = useTranslation(['headerFooter', 'common'])

    return (
        <FooterElement id="page-footer">
            <Divider />

            <aside className="footer-menu" style={{ padding: '2rem 0' }}>
                <FooterContainer>
                    <FooterContent>
                        <FooterInfo>
                            <LogoContainer>
                                <img
                                    src="/images/easywallet/logo-easywallet.png"
                                    alt="easywallet logo"
                                    className="footer-logo"
                                    width={160}
                                    height={40}
                                />
                            </LogoContainer>

                            <FooterText style={{ fontSize: '0.875rem' }}>
                                {t('footer.serviceUnavailableInCountry1')}
                            </FooterText>
                            <FooterText style={{ fontSize: '0.875rem' }}>
                                {t('footer.serviceUnavailableInCountry2')}
                            </FooterText>
                            <FooterText style={{ fontSize: '0.875rem' }}>
                                © {currentYear} EasyWallet. All rights reserved.
                            </FooterText>
                        </FooterInfo>

                        <FooterLinks>
                            <li>
                                <Link href="/contact" data-testid="footer-contact">
                                    {t('footer.contactUs')}
                                </Link>
                            </li>
                            <li>
                                <Link href="/legal/terms" data-testid="footer-terms">
                                    {t('footer.terms')}
                                </Link>
                            </li>
                            <li>
                                <Link href="/legal/privacy" data-testid="footer-policy">
                                    {t('footer.privacy')}
                                </Link>
                            </li>
                        </FooterLinks>
                    </FooterContent>
                </FooterContainer>
            </aside>
        </FooterElement>
    )
}

export default Footer
